import AOS from 'aos'

AOS.init({
//   delay: 100,
// //   offset: 200,
//   mirror: false,
//   duration: 400,
//   once: true, 
//   mirror: false, 
//   anchorPlacement: 'top-bottom',
  once: true,
  offset: 200,
});
